import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { geolocated } from 'react-geolocated';

var GetLocation = /*#__PURE__*/function (_Component) {
  _inherits(GetLocation, _Component);

  var _super = _createSuper(GetLocation);

  function GetLocation(props) {
    _classCallCheck(this, GetLocation);

    return _super.call(this, props); // this.getInnerRef = this.getInnerRef.bind(this);
  }

  _createClass(GetLocation, [{
    key: "render",
    value: function render() {
      // Dummy html for the component
      return /*#__PURE__*/React.createElement("span", null);
    }
  }]);

  return GetLocation;
}(Component);

export default geolocated({
  positionOptions: {
    enableHighAccuracy: false
  },
  userDecisionTimeout: 5000,
  suppressLocationOnMount: true // Prevent from firing automatically. Allows us to control when to fire

})(GetLocation);